if (!customElements.get('common-tab-products')) {
  class TabProducts extends HTMLElement {
    constructor() {
      super();
      this.tabList = this.querySelector('.bfcm-tab-products__tab-list');
      this.containerList = this.querySelectorAll('.bfcm-tab-products__products-container');
      this.tabSwiperContainer = this.querySelectorAll('.bfcm-tab-products__tab-wrapper');
      this.tabSwiperScrollbar = this.querySelector('.bfcm-tab-products__scrollbar');
      this.tabSwiper = undefined;
      this.showMoreBtnList = this.querySelectorAll('.bfcm-tab-products__show-more-btn');
      this.initTabSwiper();
      this.initTabEvent();
      this.initShowMoreEvent();
    }

    initTabSwiper() {
      this.tabSwiper = new Swiper(this.tabSwiperContainer, {
        slidesPerView: "auto",
        spaceBetween: 0,
        scrollbar: {
          el: this.tabSwiperScrollbar,
        },
      })
    }

    initTabEvent() {
      this.tabList.addEventListener('click', (e) => {
        const target = e.target;
        if (e.target.tagName == 'LI') {
          const tab = target.getAttribute('data-tab');
          const index = target.getAttribute('data-index');
          this.tabSwiper.slideTo(index -1);
          this.tabList.querySelector('.active')?.classList.remove('active');
          target.classList.add('active');
          for (const container of this.containerList) {
            const containerForTab = container.getAttribute('data-tab');
            if (containerForTab == tab) {
              container.classList.add('active');
            } else {
              container.classList.remove('active');
            }
          }
          // // Scroll into view
          // const container = this.tabList;
          // const containerLeft = container.scrollLeft;
          // const containerWidth = container.clientWidth;
          // const itemLeft = target.offsetLeft - container.offsetLeft;
          // const itemWidth = target.offsetWidth;
          // // console.log(containerLeft, containerWidth, itemLeft, itemWidth);
          // if (itemLeft < containerLeft || itemLeft + itemWidth > containerLeft + containerWidth) {
          //   container.scroll({
          //     left: itemLeft,
          //     behavior: 'smooth'
          //   });
          // }
        }
      });
    }

    initShowMoreEvent() {
      const columns = 4;
      const showMoreLimit = parseInt(this.dataset.showMoreLimit, 10) || 8;
      const visibleRows = Math.max(1, Math.ceil(showMoreLimit / columns));
      this.querySelectorAll('.bfcm-tab-products__products-container-inner .swiper-wrapper').forEach((e) => {
        if (e.classList.contains('need-show-more')) {
          const items = Array.from(e.children);
          const itemNum = e.childElementCount;
          const rowNum = Math.ceil(itemNum / columns);
          const parent = e.parentElement;
          const showMoreBtn = parent.querySelector('.bfcm-tab-products__show-more-btn');
          
          const itemBoxNormal = document.createElement('div');
          const itemBoxExpand = document.createElement('div');
          e.innerHTML = '';
          itemBoxNormal.className = 'normal-box';
          itemBoxNormal.style.setProperty('grid-template-rows', `repeat(${visibleRows}, 1fr)`);
          
          itemBoxExpand.className = 'expand-box';
          itemBoxExpand.style.setProperty('grid-template-rows', `repeat(${Math.max(0, rowNum - visibleRows)}, 1fr)`); 
          let itemBoxExpandNum = 0;
          items.forEach(el => {
            if (el.classList.contains('large-card') || el.classList.contains('medium-card')) {
              itemBoxExpandNum += 1;
            }
          })

          if (itemBoxExpandNum === 0) {
            itemBoxExpandNum = showMoreLimit;
          } else {
            itemBoxExpandNum += 8;
          }

          // 分配元素到两个容器
          items.forEach((item, index) => {
            if (index < itemBoxExpandNum) {
              itemBoxNormal.appendChild(item);
            } else {
              itemBoxExpand.appendChild(item);
            }
          });
          e.appendChild(itemBoxNormal);
          e.appendChild(itemBoxExpand);

          if (itemNum <= itemBoxExpandNum) {
            showMoreBtn.style.setProperty('display', 'none');
            itemBoxNormal.style.setProperty('grid-template-rows', `repeat(${rowNum}, 1fr)`);
          }

          showMoreBtn.addEventListener('click', () => {
            e.classList.toggle('collapsed');
            e.classList.toggle('expanded');
          });
        }
      });
    }
  }

  customElements.define('common-tab-products', TabProducts);
}


if (!customElements.get('bfcm-tab-products-swiper')) {
  class BfcmTabProductsSwiper extends HTMLElement {
    constructor() {
      super();
      this._swiperInstance = null;
      this.columnsDesktop = Number(this.getAttribute("data-columns-desktop") ?? 2);
      this._swiperContainer = this;

      const isMobile = `(max-width: 768px)`;
      const isMobileMQL = window.matchMedia(isMobile);

      isMobileMQL.addEventListener('change', (event) => {
        if (!event.matches) {
          this.createSlider();
        } else if (this.mySwiper) {
          this.destroySwiper();
        }
      });
      if (!isMobileMQL.matches) this.createSlider();
    }

    createSlider() {
      const nextButton = this.querySelector('.swiper-btn-next');
      const prevButton = this.querySelector('.swiper-btn-prev');
      const pagination = this.querySelector(`.swiper-pagination`);

      this._swiperInstance = new Swiper(this._swiperContainer, {
        slidesPerView: 3,
        slidesPerGroup: 1,
        spaceBetween: 20,
        loop: false,
        direction: "horizontal",
        navigation: {
          nextEl: nextButton,
          prevEl: prevButton,
        },
        pagination: {
          el: pagination,
          clickable: true,
        },
        breakpoints: {
          769: {
            slidesPerView: 2,
            spaceBetween: 20,
          },
          990: {
            slidesPerView: 2,
            spaceBetween: 20,
          },
          1200: {
            slidesPerView: 2.5,
            spaceBetween: 20,
          },
        }
      });
    }

    destroySwiper() {
      this._swiperInstance.destroy();
    }
  }

  customElements.define('bfcm-tab-products-swiper', BfcmTabProductsSwiper);
}